import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
    bulkUpdateDownloadStatus,
    fetchHailuoVideosFromDB,
} from '../../services/api';
import { message } from 'antd';

// Async thunks
export const fetchVideos = createAsyncThunk(
    'video/fetchVideos',
    async (
        { userId, filters = {}, page = 1, limit = 10 },
        { rejectWithValue },
    ) => {
        try {
            const queryOptions = {
                ...filters,
                page,
                limit,
            };
            // Gọi API backend đã optimize
            const result = await fetchHailuoVideosFromDB(userId, queryOptions);

            return result;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    },
);

export const downloadVideos = createAsyncThunk(
    'downloadVideos',
    async ({ ids = [], isDownloaded }, { rejectWithValue }) => {
        try {
            // Gọi API backend đã optimize
            const result = await bulkUpdateDownloadStatus(ids, isDownloaded);

            return result;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    },
);

// Trong videoSlice.js
const initialState = {
    videos: [],
    loading: false,
    error: null,
    videoId: '',
    videoSelected: {},
    pagination: {
        total: 0,
        page: 0,
        limit: 0,
        totalPages: 0,
        hasNextPage: false,
        hasPrevPage: false,
    },
};

// Slice
const videoSlice = createSlice({
    name: 'video',
    initialState,
    reducers: {
        setVideoId: (state, action) => {
            state.videoId = action.payload;
            state.videoSelected = state.videos.find(
                (item) => item.id === state.videoId,
            );
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchVideos.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchVideos.fulfilled, (state, action) => {
                state.loading = false;
                state.videos = action.payload.data;
                state.pagination = action.payload.pagination;
            })
            .addCase(fetchVideos.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            ////////////////////////////////////
            .addCase(downloadVideos.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(downloadVideos.fulfilled, (state, action) => {
                state.loading = false;
                message.success(`Đã tải tât cả video thành công`);
                state.error = null;
            })
            .addCase(downloadVideos.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { setVideoId } = videoSlice.actions;

export default videoSlice.reducer;
